export const Loader = ({ ratio, fill }) => {
  return (
    <svg
      className="rotationAnimation"
      xmlns="http://www.w3.org/2000/svg"
      width={ratio ? ratio : "48"}
      height={ratio ? ratio : "48"}
      enableBackground="new 0 0 512 512"
      viewBox="0 0 24 24"
      fill={fill || "#5763F3"}
    >
      <path d="M12 22C6.49 22 2 17.51 2 12c0-1.87.52-3.69 1.5-5.27a1.003 1.003 0 011.7 1.06A8.008 8.008 0 004 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10z"></path>
    </svg>
  );
};
